/* eslint-disable */
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Grid,
  IconButton,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const nameItemText = "Armazón";
//
// ###########################################################################
//
const ValorArmazonDialog = ({ onClose, articuloData }) => {
  const handleCloseDialog = () => {
    onClose();
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Dialog
        open={true}
        onClose={(event, reason) => {
          if (reason === "backdropClick" || reason === "escapeKeyDown") {
            return;
          }
          handleCloseDialog();
        }}
        disableEscapeKeyDown={true}
        maxWidth="md"
        fullWidth={true}
        scroll="paper"
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          Ver {nameItemText}
          <IconButton
            aria-label="close"
            onClick={handleCloseDialog}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <TextField
                sx={{ width: "100%", mb: 1 }}
                id="codigo"
                label="Código"
                variant="outlined"
                size="small"
                name="codigo"
                value={articuloData.codigo ?? ""}
                disabled={true}
              />
            </Grid>
          </Grid>

          <Grid container spacing={1}>
            <Grid item xs={12}>
              <TextField
                sx={{ width: "100%", mb: 1 }}
                id="descripcion"
                label="Descripción"
                variant="outlined"
                size="small"
                name="descripcion"
                value={articuloData.descripcion ?? ""}
                disabled={true}
              />
            </Grid>
          </Grid>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <TextField
                sx={{ width: "100%", mb: 1 }}
                id="descripcionArAsMarca"
                label="Marca"
                variant="outlined"
                size="small"
                name="descripcionArAsMarca"
                value={articuloData.descripcionArAsMarca ?? ""}
                disabled={true}
              />
            </Grid>
          </Grid>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <TextField
                sx={{ width: "100%", mb: 1 }}
                id="modelo"
                label="Modelo"
                variant="outlined"
                size="small"
                name="modelo"
                value={articuloData.modelo ?? ""}
                disabled={true}
              />
            </Grid>
          </Grid>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <TextField
                sx={{ width: "100%", mb: 1 }}
                id="descripcionArAsCategoria"
                label="Categoría"
                variant="outlined"
                size="small"
                name="descripcionArAsCategoria"
                value={articuloData.descripcionArAsCategoria ?? ""}
                disabled={true}
              />
            </Grid>
          </Grid>
          <Grid container spacing={1}>
            <Grid item xs={6}>
              <TextField
                sx={{ width: "100%", mb: 1 }}
                id="descripcionArAsMaterial"
                label="Material"
                variant="outlined"
                size="small"
                name="descripcionArAsMaterial"
                value={articuloData.descripcionArAsMaterial ?? ""}
                disabled={true}
              />
            </Grid>

            <Grid item xs={6}>
              <TextField
                sx={{ width: "100%", mb: 1 }}
                id="descripcionArAsFormato"
                label="Formato"
                variant="outlined"
                size="small"
                name="descripcionArAsFormato"
                value={articuloData.descripcionArAsFormato ?? ""}
                disabled={true}
              />
            </Grid>
          </Grid>
          <Grid container spacing={1}>
            <Grid item xs={6}>
              <TextField
                sx={{ width: "100%", mb: 1 }}
                id="descripcionArAsCalibre"
                label="Calibre"
                variant="outlined"
                size="small"
                name="descripcionArAsCalibre"
                value={articuloData.descripcionArAsCalibre ?? ""}
                disabled={true}
              />
            </Grid>

            <Grid item xs={6}>
              <TextField
                sx={{ width: "100%", mb: 1 }}
                id="descripcionArAsTipo"
                label="Tipo"
                variant="outlined"
                size="small"
                name="descripcionArAsTipo"
                value={articuloData.descripcionArAsTipo ?? ""}
                disabled={true}
              />
            </Grid>
          </Grid>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <TextField
                sx={{ width: "100%", mb: 1 }}
                id="descripcionArAsColor"
                label="Colores"
                variant="outlined"
                size="small"
                name="descripcionArAsColor"
                value={articuloData.descripcionArAsColor ?? ""}
                disabled={true}
              />
            </Grid>
          </Grid>
          <Grid container spacing={1}>
            <Grid item xs={3}>
              <TextField
                sx={{ width: "100%", mb: 1 }}
                id="ultimoCosto"
                label="Último Costo $"
                variant="outlined"
                size="small"
                name="ultimoCosto"
                value={
                  articuloData.ultimoCosto
                    ? articuloData.ultimoCosto.toFixed(2)
                    : "0.00"
                }
                disabled={true}
              />
            </Grid>

            <Grid item xs={3}>
              <TextField
                sx={{ width: "100%", mb: 1 }}
                id="fechaUltimoCosto"
                label="Fecha Último Costo"
                variant="outlined"
                size="small"
                name="fechaUltimoCosto"
                value={articuloData.fechaUltimoCosto ?? ""}
                disabled={true}
              />
            </Grid>

            <Grid item xs={3}>
              <TextField
                sx={{ width: "100%", mb: 1 }}
                id="valorDolarUltimo"
                label="Valor U$S Último"
                variant="outlined"
                size="small"
                name="valorDolarUltimo"
                value={
                  articuloData.valorDolarUltimo
                    ? articuloData.valorDolarUltimo.toFixed(2)
                    : "0.00"
                }
                disabled={true}
              />
            </Grid>

            <Grid item xs={3}>
              <TextField
                sx={{ width: "100%", mb: 1 }}
                id="ultimoCostoEnDolar"
                label="Último Costo en U$S"
                variant="outlined"
                size="small"
                name="ultimoCostoEnDolar"
                value={
                  articuloData.ultimoCostoEnDolar
                    ? articuloData.ultimoCostoEnDolar.toFixed(2)
                    : "0.00"
                }
                disabled={true}
              />
            </Grid>
          </Grid>
          <Grid container spacing={1}>
            <Grid item xs={3}>
              <TextField
                sx={{ width: "100%", mb: 1 }}
                id="actualCosto"
                label="Costo Actual $"
                variant="outlined"
                size="small"
                name="actualCosto"
                value={
                  articuloData.actualCosto
                    ? articuloData.actualCosto.toFixed(2)
                    : "0.00"
                }
                disabled={true}
              />
            </Grid>

            <Grid item xs={3}>
              <TextField
                sx={{ width: "100%", mb: 1 }}
                id="fechaActualCosto"
                label="Fecha Costo Actual"
                variant="outlined"
                size="small"
                name="fechaActualCosto"
                value={articuloData.fechaActualCosto ?? ""}
                disabled={true}
              />
            </Grid>

            <Grid item xs={3}>
              <TextField
                sx={{ width: "100%", mb: 1 }}
                id="valorDolarActual"
                label="Valor Actual U$S"
                variant="outlined"
                size="small"
                name="valorDolarActual"
                value={
                  articuloData.valorDolarActual
                    ? articuloData.valorDolarActual.toFixed(2)
                    : "0.00"
                }
                disabled={true}
              />
            </Grid>

            <Grid item xs={3}>
              <TextField
                sx={{ width: "100%", mb: 1 }}
                id="actualCostoEnDolar"
                label="Costo Actual en U$S"
                variant="outlined"
                size="small"
                name="actualCostoEnDolar"
                value={
                  articuloData.actualCostoEnDolar
                    ? articuloData.actualCostoEnDolar.toFixed(2)
                    : "0.00"
                }
                disabled={true}
              />
            </Grid>
          </Grid>
          <Grid container spacing={1}>
            <Grid item xs={3}>
              <TextField
                sx={{ width: "100%", mb: 1 }}
                id="previoVentaContado"
                label="PV Contado $"
                variant="outlined"
                size="small"
                name="previoVentaContado"
                value={
                  articuloData.previoVentaContado
                    ? articuloData.previoVentaContado.toFixed(2)
                    : "0.00"
                }
                disabled={true}
              />
            </Grid>

            <Grid item xs={3}>
              <TextField
                sx={{ width: "100%", mb: 1 }}
                id="futContado"
                label="Factor Utilidad Contado"
                variant="outlined"
                size="small"
                name="futContado"
                value={
                  articuloData.futContado
                    ? articuloData.futContado.toFixed(4)
                    : "0.00"
                }
                disabled={true}
              />
            </Grid>

            <Grid item xs={3}>
              <TextField
                sx={{ width: "100%", mb: 1 }}
                id="precioVentaLista"
                label="PV Lista $"
                variant="outlined"
                size="small"
                name="precioVentaLista"
                value={
                  articuloData.precioVentaLista
                    ? articuloData.precioVentaLista.toFixed(2)
                    : "0.00"
                }
                disabled={true}
              />
            </Grid>

            <Grid item xs={3}>
              <TextField
                sx={{ width: "100%", mb: 1 }}
                id="futLista"
                label="Factor Utilidad Lista"
                variant="outlined"
                size="small"
                name="futLista"
                value={
                  articuloData.futLista
                    ? articuloData.futLista.toFixed(4)
                    : "0.00"
                }
                disabled={true}
              />
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <Button
            sx={{ mr: 2 }}
            variant="outlined"
            size="small"
            onClick={handleCloseDialog}
          >
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
export default ValorArmazonDialog;
